import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import todoReducer from './todoSlice';

const store = configureStore({
  reducer: {
    auth:  authReducer,
    todos: todoReducer,
  },
});

export default store;
